import React, { useContext, useEffect, useState } from "react";

import { Grid, TableCell, TableRow, makeStyles } from "@material-ui/core";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance3,
  TYPE_INSTANCE1,
  TYPE_INSTANCE3,
  valueTipeKartu,
  valueTipePembayaran,
} from "App/constants";
import {
  METODE_PEMBAYARAN,
  RESET_STATE_PEMBAYARAN,
  headCellsDataBerhasil,
  headCellsDataGagal,
} from "./helpers";
import {
  convertToValidPrice,
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
  statusSucess,
} from "App/utils/helpers";
import {
  InputFileCustom,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import useSelectOptionCustom from "App/hooks/useSelectOptionCustom";
import moment from "moment";
import { useDatatables, useSelectOption } from "App/hooks";
import { FormContext } from "../context/FormContext";
import InputCheckboxMaster from "App/Component/ui/input/InputCheckboxMaster/InputCheckboxMaster";
import { Save } from "@material-ui/icons";
import TabCount from "App/Component/ui/Tab/TabCount";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { RenderStatusPembelian } from "App/Component/layout/Penjualan/DaftarPenjualan/helpers";
import { FreezeTableClient } from "components/organism";
import { Alert } from "@material-ui/lab";

const SHOW_LOAD_BUTTON = {
  label: "PROSES",
  color: "green",
  state: false,
  disabled: false,
};

const useStyles = makeStyles({
  error: {
    color: "red",
    fontSize: "9px",
    marginTop: "2px",
    marginLeft: "2px",
    position: "absolute",
  },
  withButton: {
    display: "flex",
  },
  row: {
    display: "flex",
    alignItems: "center",
  },
});

const ModalBayar = ({
  setShowModal,
  setNewData,
  nilai,
  id,
  total,
  diskon,
  totalDiskon,
  bayarDiskon,
  asuransi_id,
  asuransi_nama,
  countTotal,
}) => {
  const [formData, setFormData] = useState({
    ...RESET_STATE_PEMBAYARAN,
    jumlah_bayar2: nilai,
    id: id,
    total_harga: total,
    diskon: diskon,
    total_bayar_diskon: bayarDiskon,
    total_diskon: totalDiskon,
    asuransi_id: asuransi_id,
    asuransi_nama: asuransi_nama,
  });

  const { rowsSelect, setRowsSelect, rowsTagihan } = useContext(FormContext);
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  const [disabledUpload, setDisabledUpload] = useState(SHOW_LOAD_BUTTON);
  const [file, setFile] = useState(null);
  const [rowsBerhasil, setRowsBerhasil] = useState([]);
  const [rowsGagal, setRowsGagal] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [totalDataGagal, setTotalDataGagal] = useState(0);
  const [totalDataBerhasil, setTotalDataBerhasil] = useState(0);
  const [totalBayarImport, setTotalBayarImport] = useState(0);
  const kasBank = useSelectOptionCustom(
    true,
    "/kas/kas/list",
    TYPE_INSTANCE3,
    "id",
    "nama",
    "id_coa"
  );

  const bank = useSelectOption(true, "/bank/listbank", TYPE_INSTANCE1);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formData.kas_id)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Pilih kas bank terlebih dahulu");
    } else {
      try {
        if (
          formData.metode_pembayaran == 2
            ? isNull(parseFloat(convertToValidPrice(totalBayarImport)))
            : // ||
              //   parseFloat(convertToValidPrice(totalBayarImport)) <= 0
              isNull(parseFloat(convertToValidPrice(formData.jumlah_bayar2)))
          // ||
          //   parseFloat(convertToValidPrice(formData.jumlah_bayar2)) <= 0
        ) {
          defaultToastError("Harap isi jumlah pembayaran");
        } else {
          if (
            parseFloat(convertToValidPrice(formData.jumlah_bayar2)) >
            parseFloat(convertToValidPrice(nilai))
          ) {
            defaultToastError("Harga tidak boleh lebih dari jumlah tagihan!");
          } else {
            // const cek_jumlah_diskon = parseFloat(convertToValidPrice(formData.jumlah_bayar2)) - (parseFloat(formData.total_diskon) - parseFloat(formData.total_bayar_diskon));
            // if(formData.isDiskon && cek_jumlah_diskon < 0){
            //   defaultToastError("Harga diskon melebih dari jumlah tagihan!");
            // }else{
            const defaultData = {
              id_rekap: formData.id,
              tanggal_masuk: moment(formData.tanggal_masuk).utc(),
              // jumlah_bayar: formData.isDiskon
              //   ? parseFloat(convertToValidPrice(formData.jumlah_bayar2)) +
              //     (parseFloat(formData.total_diskon) -
              //       parseFloat(formData.total_bayar_diskon))
              //   : parseFloat(convertToValidPrice(formData.jumlah_bayar2)),
              jumlah_bayar:
                formData.metode_pembayaran == 2
                  ? parseFloat(convertToValidPrice(totalBayarImport))
                  : parseFloat(convertToValidPrice(formData.jumlah_bayar2)),
              tipe_pembayaran_id: formData.tipe_pembayaran_id,
              kas_id: formData.kas_id,
              tipe_kartu: parseInt(formData.tipe_kartu),
              no_kartu: formData.no_kartu,
              no_transfer: formData.no_transfer,
              kartu_bank: formData.kartu_bank,
              coa_code: formData.coa_code,
              coa_name: "",
              no_kwitansi: "",
              diskon: formData.diskon,
              total_harga_diskon: formData.isDiskon
                ? parseFloat(formData.total_diskon) -
                  parseFloat(formData.total_bayar_diskon)
                : 0,
              jumlah_bayar_diskon: formData.isDiskon
                ? parseFloat(convertToValidPrice(formData.jumlah_bayar2)) -
                  (parseFloat(formData.total_diskon) -
                    parseFloat(formData.total_bayar_diskon))
                : parseFloat(convertToValidPrice(formData.jumlah_bayar2)),
              listTagihan:
                formData.metode_pembayaran == 2
                  ? rowsBerhasil
                  : rowsSelect.length === 0
                  ? []
                  : rowsSelect,
              is_diskon: formData.isDiskon,
              asuransi_id: formData.asuransi_id,
              asuransi_nama: formData.asuransi_nama,
            };

            const res = await instance3.post(
              "/rekap-tagihan/v2/bayar",
              defaultData
            );
            if (res.data.status === 200) {
              setRowsSelect([]);
              defaultToastSuccess(
                "Berhasil menyimpan data pembayaran, silahkan jalankan pembayaran pada Detail Pembayaran di TAB PEMBAYARAN !"
              );
              await setNewData();
              setShowModal(false);
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            } else {
              defaultToastError(res.data.message);
              setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
            }

            // if (rowsSelect.length === 0) {
            //   const cekTotalDibayar = rowsTagihan.filter(
            //     (e) => e.totaltagihan !== e.total_dibayar
            //   );
            //   if (cekTotalDibayar.length > 500) {
            //     setRowsSelect([]);
            //     defaultToastSuccess(
            //       "Pembayaran dalam proses, silahkan cek secara berkala pada Log Proses"
            //     );
            //     instance3.post("/rekap-tagihan/upload-bayar", defaultData);
            //   } else {
            //     const res = await instance3.post(
            //       "/rekap-tagihan/bayar",
            //       defaultData
            //     );
            //     if (res.data.status === 200) {
            //       setRowsSelect([]);
            //       defaultToastSuccess("Berhasil melakukan pembayaran");
            //       await setNewData();
            //     } else {
            //       defaultToastError(res.data.message);
            //     }
            //   }
            // } else {
            //   if (rowsSelect.length > 500) {
            //     setRowsSelect([]);
            //     defaultToastSuccess(
            //       "Pembayaran dalam proses, silahkan cek secara berkala pada Log Proses"
            //     );
            //     instance3.post("/rekap-tagihan/upload-bayar", defaultData);
            //   } else {
            //     const res = await instance3.post(
            //       "/rekap-tagihan/bayar",
            //       defaultData
            //     );
            //     if (res.data.status === 200) {
            //       setRowsSelect([]);
            //       defaultToastSuccess("Berhasil melakukan pembayaran");
            //       await setNewData();
            //     } else {
            //       defaultToastError(res.data.message);
            //     }
            //   }
            // }
          }
          // }
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleReset = () => {
    setRowsBerhasil([]);
    setRowsGagal([]);
    setTotalData(0);
    setTotalDataGagal(0);
    setTotalDataBerhasil(0);
    setTotalBayarImport(0);
    setFile(null);
  };

  useEffect(() => {
    handleReset();
  }, [formData.metode_pembayaran]);

  const handleClickUpload = async () => {
    setDisabledUpload(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(file)) {
        setDisabledUpload(SHOW_LOAD_BUTTON);
        defaultToastError("Harap pilih file terlebih dahulu");
      } else {
        const newFormData = new FormData();
        newFormData.append("excelFile", file);
        newFormData.append("rekap_tagihan_id", formData.id);

        const api = await instance3.post(
          "/rekap-tagihan/v2/bayar/upload",
          newFormData
        );
        const res = api.data;
        if (statusSucess(res.status)) {
          setRowsBerhasil(res.data.data_masuk);
          setRowsGagal(res.data.data_error);
          setTotalData(res.data.Jumlah_data);
          setTotalDataGagal(res.data.jumlah_data_gagal);
          setTotalDataBerhasil(res.data.jumlah_data_masuk);
          setTotalBayarImport(
            formatRupiah(
              convertToValidPrice(countTotal(res.data.data_masuk).sisa_tagihan)
            )
          );
          setFile(null);
        } else {
          handleReset();
          defaultToastError(
            "Terjadi kesalahan ! Silahkan periksa kembali file excel yang diupload"
          );
        }
        setDisabledUpload(SHOW_LOAD_BUTTON);
      }
    } catch (error) {
      setDisabled(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const classes = useStyles();
  return (
    <Modal
      title={`Pembayaran ${
        rowsSelect.length === 0
          ? ""
          : "(" + rowsSelect.length + " Tagihan Terpilih)"
      }`}
      show={setShowModal}
      width={formData.metode_pembayaran == 2 ? "90%" : "60%"}
    >
      <div className="mb-1">
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputOptionMaster
              name="metode_pembayaran"
              label="METODE PEMBAYARAN"
              id="metode_pembayaran"
              withSearch={false}
              value={formData.metode_pembayaran}
              onChange={handleChange("metode_pembayaran")}
              data={METODE_PEMBAYARAN}
            />
          </Grid>
          {formData.metode_pembayaran == 2 ? (
            <>
              <Grid item sm={10}>
                <label
                  htmlFor="fileBayarTagihanImport"
                  style={{
                    fontWeight: 400,
                    color: "#BDBDBD",
                    fontSize: "11px",
                  }}
                >
                  Pilih File
                </label>
                <InputFileCustom
                  convertToBase64={false}
                  label={"Upload File"}
                  name={"fileBayarTagihanImport"}
                  id={"fileBayarTagihanImport"}
                  initialNameFile={file}
                  setFile={setFile}
                  accept={".xls, .xlsx"}
                />
                <label
                  style={{
                    position: "absolute",
                    left: "23px",
                    fontWeight: 400,
                    color: "#BDBDBD",
                    fontSize: "11px",
                  }}
                >
                  *File yang diizinkan .xls, .xlsx; Sempel bisa didownload pada
                  DAFTAR EXPORT, setelah menekan tombol EXCEL berwarna KUNING
                  pada bagian bawah menu ini
                </label>
              </Grid>
              <Grid item sm={2}>
                <MasterButton
                  type="submit"
                  outline={true}
                  name={disabledUpload.label}
                  disabled={disabledUpload.disabled}
                  color={disabledUpload.color}
                  className={"ml-1"}
                  onClick={() =>
                    disabledUpload.disabled ? null : handleClickUpload()
                  }
                  size="sm"
                  withIcon={true}
                  style={{
                    padding: "0.5rem 1.9rem",
                    fontSize: "15px",
                    marginTop: "24px",
                  }}
                  icon={
                    <Save
                      width="15px"
                      height="15px"
                      style={{
                        marginLeft: "-0.5rem",
                      }}
                    />
                  }
                />
              </Grid>
              <Grid item sm={12}>
                <div className="count-card">
                  <Grid container spacing={2}>
                    <Grid item sm={12} md={4}>
                      <TabCount
                        title={"TOTAL DATA"}
                        total={formatNumber(totalData)}
                      />
                    </Grid>
                    <Grid item sm={12} md={4}>
                      <TabCount
                        title={"JUMLAH DATA MASUK"}
                        total={formatNumber(totalDataBerhasil)}
                      />
                    </Grid>
                    <Grid item sm={12} md={4}>
                      <TabCount
                        title={"JUMLAH DATA GAGAL"}
                        total={formatNumber(totalDataGagal)}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item md={8} sm={12}>
                <TableDataBerhasil rowsDataBerhasil={rowsBerhasil} />
              </Grid>
              <Grid item md={4} sm={12}>
                <TableDataGagal rowsDataGagal={rowsGagal} />
              </Grid>
            </>
          ) : (
            <></>
          )}
        </Grid>
      </div>

      <form
        onSubmit={(e) =>
          formData.metode_pembayaran == 2
            ? totalDataGagal == 0
              ? totalData > 0
                ? handleSubmit(e)
                : null
              : null
            : handleSubmit(e)
        }
      >
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Grid container spacing={1}>
              <Grid item sm={6}>
                <InputReactDatepicker
                  selected={formData.tanggal_masuk}
                  label="TANGGAL"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      tanggal_masuk: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      tanggal_masuk: e,
                    })
                  }
                />
              </Grid>
              <Grid item sm={6}>
                <InputOptionMaster
                  name="tipe_pembayaran_id"
                  label="TIPE PEMBAYARAN"
                  id="tipe_pembayaran_id"
                  withSearch={false}
                  value={formData.tipe_pembayaran_id}
                  onChange={handleChange("tipe_pembayaran_id")}
                  data={valueTipePembayaran}
                />
              </Grid>
              <Grid item sm={6}>
                <InputOptionMaster
                  name="kas_id"
                  label="KAS"
                  id="kas_id"
                  data={kasBank}
                  withSearch={true}
                  value={formData.kas_id}
                  labelValue={formData.kas_name}
                  onChange={(e) => {
                    if (isNull(e)) {
                      setFormData({
                        ...formData,
                        kas_id: null,
                        kas_name: "Pilih kas",
                        coa_code: "",
                      });
                    } else {
                      setFormData({
                        ...formData,
                        kas_id: e?.value,
                        kas_name: e?.label,
                        coa_code: e?.code,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item sm={6}>
                <InputTextMaster
                  name="jumlah_bayar2"
                  label="PEMBAYARAN"
                  id="jumlah_bayar2"
                  disabled={
                    formData.metode_pembayaran == 2 || rowsSelect.length > 0
                      ? true
                      : false
                  }
                  value={
                    formData.metode_pembayaran == 2
                      ? totalBayarImport
                      : formData.jumlah_bayar2
                  }
                  onInput={(e) => {
                    let val = e.target.value;
                    setFormData({
                      ...formData,
                      jumlah_bayar2: formatRupiah(val),
                    });
                  }}
                  withButtonLeft={true}
                >
                  <button
                    type={"button"}
                    onClick={null}
                    style={{
                      borderLeft: "1px solid #EAEAEA",
                      borderTop: "1px solid #EAEAEA",
                      borderBottom: "1px solid #EAEAEA",
                      borderRight: "0",
                      background:
                        formData.metode_pembayaran == 2 || rowsSelect.length > 0
                          ? "#F7F7F7"
                          : "#fff",
                      padding: "0 0 0 0.8rem",
                      cursor: "pointer",
                      borderRadius: "6px 0 0 6px",
                      fontSize: "10px",
                    }}
                  >
                    Rp.
                  </button>
                </InputTextMaster>
                <div
                  style={{
                    cursor: "pointer",
                    marginTop: `${
                      formData.metode_pembayaran == 2 || rowsSelect.length > 0
                        ? "-4.6rem"
                        : parseFloat(
                            convertToValidPrice(formData.jumlah_bayar2)
                          ) <
                          parseFloat(formData.total_diskon) -
                            parseFloat(formData.total_bayar_diskon)
                        ? "-4.6rem"
                        : "-3.7rem"
                    }`,
                    position: "absolute",
                    right: "2rem",
                  }}
                >
                  <InputCheckboxMaster
                    checked={formData.isDiskon}
                    name="isDiskon"
                    id="isDiskon"
                    label="Dengan Diskon"
                    disabled={
                      formData.metode_pembayaran == 2 || rowsSelect.length > 0
                        ? true
                        : convertToValidPrice(formData.jumlah_bayar2) === 0 ? false
                        : parseFloat(
                            convertToValidPrice(formData.jumlah_bayar2)
                          ) <
                          parseFloat(formData.total_diskon) -
                            parseFloat(formData.total_bayar_diskon)
                        ? true
                        : false
                    }
                    onChange={() =>
                      setFormData({
                        ...formData,
                        isDiskon: !formData.isDiskon,
                      })
                    }
                  />
                  <p className={classes.error}>
                    {" "}
                    {formData.metode_pembayaran == 2 || rowsSelect.length > 0
                      ? "Tidak dapat digunakan"
                      : convertToValidPrice(formData.jumlah_bayar2) === 0
                      ? ""
                      : parseFloat(
                          convertToValidPrice(formData.jumlah_bayar2)
                        ) <
                        parseFloat(formData.total_diskon) -
                          parseFloat(formData.total_bayar_diskon)
                      ? "Diskon melebihi bayar"
                      : ""}{" "}
                  </p>
                </div>
              </Grid>
              {formData.tipe_pembayaran_id.toString() === "2" && (
                <Grid item sm={12}>
                  <Grid container spacing={1}>
                    <FormTipeKartuNoKartuDanNoTransfer
                      formData={formData}
                      handleChange={handleChange}
                      setFormData={setFormData}
                      bank={bank}
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
            {formData.metode_pembayaran == 2 && totalDataGagal > 0 ? (
              <>
                <Grid container direction="row">
                  {
                    <Alert
                      severity="error"
                      variant="outlined"
                      style={{ width: "100%", marginTop: "1rem" }}
                    >
                      Tidak dapat melanjutkan pembayaran, dikarenakan terdapat
                      data yang gagal ! Silahkan periksa KETERANGAN pada DAFTAR
                      DATA GAGAL
                    </Alert>
                  }
                </Grid>
              </>
            ) : (
              <></>
            )}

            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <div>
                <MasterButton
                  className={"mt-1"}
                  name={"TUTUP"}
                  outline={true}
                  color={"danger"}
                  type={"button"}
                  size={"md"}
                  onClick={(e) => setShowModal(false)}
                />
                {formData.metode_pembayaran == 2 ? (
                  <MasterButton
                    className={"mt-1 ml-1"}
                    name={"RESET DATA IMPORT"}
                    outline={true}
                    color={"danger"}
                    type={"button"}
                    size={"md"}
                    onClick={(e) => handleReset()}
                  />
                ) : (
                  <></>
                )}
              </div>

              <MasterButton
                className={"mt-1"}
                type={"submit"}
                color={
                  formData.metode_pembayaran == 2
                    ? totalDataGagal == 0
                      ? totalData > 0
                        ? disabled.color
                        : "secondary"
                      : "secondary"
                    : disabled.color
                }
                name={disabled.label}
                disabled={
                  formData.metode_pembayaran == 2
                    ? totalDataGagal == 0
                      ? totalData > 0
                        ? disabled.disabled
                        : true
                      : true
                    : disabled.disabled
                }
                size={"md"}
              />
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Modal>
  );
};

const FormTipeKartuNoKartuDanNoTransfer = ({
  formData,
  handleChange,
  bank,
  setFormData,
}) => {
  return (
    <>
      <Grid item sm={12}>
        <InputOptionMaster
          name="tipe_kartu"
          label="TIPE KARTU"
          id="tipe_kartu"
          withSearch={true}
          value={formData.tipe_kartu}
          labelValue={formData.tipe_kartu_nama}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                tipe_kartu: null,
                tipe_kartu_nama: "Pilih Bank",
              });
            } else {
              setFormData({
                ...formData,
                tipe_kartu: e?.value,
                tipe_kartu_nama: e?.label,
              });
            }
          }}
          data={valueTipeKartu}
        />
      </Grid>

      <Grid item sm={12}>
        <InputOptionMaster
          name="kartu_bank"
          label="KARTU BANK"
          id="kas_id"
          data={bank}
          withSearch={true}
          value={formData.kartu_bank}
          labelValue={formData.kartu_bank_name}
          onChange={(e) => {
            if (isNull(e)) {
              setFormData({
                ...formData,
                kartu_bank: null,
                kartu_bank_name: "Pilih Bank",
              });
            } else {
              setFormData({
                ...formData,
                kartu_bank: e?.value,
                kartu_bank_name: e?.label,
              });
            }
          }}
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="no_kartu"
          label="NO KARTU"
          id="no_kartu"
          value={formData.no_kartu}
          onChange={handleChange("no_kartu")}
          placeholder="No Kartu"
        />
      </Grid>

      <Grid item sm={12}>
        <InputTextMaster
          name="no_transfer"
          label="NO TRANSAKI"
          id="no_transfer"
          value={formData.no_transfer}
          onChange={handleChange("no_transfer")}
          placeholder="No Transaksi"
        />
      </Grid>
    </>
  );
};

const TableDataBerhasil = ({ rowsDataBerhasil }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rowsDataBerhasil,
    orderByDefault: "nama_rm",
    orderByRow: [
      "sisa_tagihan",
      "id_tagihan",
      "nama_rm",
      "rm_id",
      "nama_asuransi",
    ],
  });

  return (
    <>
      <FreezeTableClient
        title="Daftar Data Masuk"
        setQ={setQ}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rowsDataBerhasil}
        headCells={headCellsDataBerhasil}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow hover tabIndex={-1} key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="left">{row?.id_tagihan}</TableCell>
                <TableCell align="left">{row?.nama_rm}</TableCell>
                <TableCell align="left">{row?.rm_id}</TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.tanggal_tagihan, true)}
                </TableCell>
                <TableCell align="center">
                  <RenderStatusPembelian status={row?.status_pembayaran} />
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.nama_asuransi) ? "-" : row?.nama_asuransi}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.no_asuransi) ? "-" : row?.no_asuransi}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.totaltagihan)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.total_bayar)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.sisa_tagihan)}
                </TableCell>
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </>
  );
};

const TableDataGagal = ({ rowsDataGagal }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rowsDataGagal,
    orderByDefault: "id_tagihan",
    orderByRow: ["id_tagihan", "message"],
  });

  return (
    <>
      <FreezeTableClient
        title="Daftar Data Gagal"
        setQ={setQ}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rowsDataGagal}
        headCells={headCellsDataGagal}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow hover tabIndex={-1} key={index}>
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="left">{row?.id_tagihan}</TableCell>
                <TableCell align="left">{row?.message}</TableCell>
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </>
  );
};
export default ModalBayar;
